var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _rect, _path10, _ellipse2, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUpgrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 138,
    viewBox: "0 0 121 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.282 6.19116C69.081 5.42092 70.1641 4.98828 71.2934 4.98828C72.4226 4.98828 73.5057 5.42092 74.3047 6.19116C77.2763 9.05933 88.4751 20.5265 98.9637 35.3445C109.322 49.9815 119.589 68.6986 119.589 85.8748C119.589 102.552 114.378 115.346 105.441 123.973C96.5319 132.583 84.3558 136.602 71.2934 136.602C58.2366 136.602 46.0605 132.583 37.1457 123.973C28.2083 115.346 22.998 102.546 22.998 85.8748C22.998 68.6986 33.2651 49.9815 43.623 35.3445C54.1116 20.5265 65.3104 9.05933 68.282 6.19116V6.19116Z",
    fill: "url(#paint0_linear_6334_53592)",
    stroke: "#262626",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.377 102.602C81.4019 105.777 80.1394 108.256 77.1204 109.345C74.0015 110.469 70.7329 110.65 68.2578 107.944C66.0272 105.505 65.5182 102.466 66.6659 99.2866C67.4494 97.1147 69.1161 96.248 71.2719 96.8779C72.3897 97.2054 73.4077 97.5985 74.5604 97.2205C79.5356 95.5929 81.382 97.0492 81.377 102.602Z",
    fill: "#0B0F0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8804 102.924C74.3754 102.737 76.2667 103.785 77.644 105.826C78.0133 106.375 77.8636 106.98 77.3047 107.298C75.1689 108.522 72.9782 108.331 70.8075 107.398C69.4751 106.824 68.2774 105.695 68.512 104.335C68.7964 102.662 70.5779 103.014 71.8804 102.924Z",
    fill: "#F2BED5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2417 104.653C76.4222 101.483 73.3683 100.773 69.9201 101.241C69.2913 101.327 68.2982 102.224 68.1735 100.712C68.0986 99.79 68.7973 98.898 69.5009 98.9837C72.2555 99.3163 74.8454 98.8577 77.545 98.5201C79.9104 98.2328 79.5511 101.831 79.2417 104.653Z",
    fill: "#A09DCA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8009 83.4554C63.7759 86.9274 61.0912 89.7343 58.7907 92.6974C58.4814 93.0955 57.5232 93.161 56.8895 93.1005C53.2866 92.7528 49.9581 91.5837 47.2884 89.059C45.0927 86.9829 44.3143 84.2667 45.6666 81.5002C46.969 78.8294 49.2695 77.6653 52.2237 78.9755C53.2067 79.4089 53.6808 78.9755 54.2497 78.3355C56.0761 76.2846 58.2718 75.831 60.722 77.0304C63.0773 78.1793 63.721 80.326 63.8009 83.4554Z",
    fill: "#0B0D0C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.895 82.1444C61.5706 85.7222 60.1634 87.9345 58.6563 90.1013C57.9727 91.089 57.0046 91.215 55.9317 91.0336C52.7829 90.5095 50.1681 88.9574 48.0422 86.6142C46.7598 85.2032 46.4753 83.4646 47.6979 81.9126C48.9055 80.3756 50.6122 80.0077 52.219 81.2625C53.6462 82.3762 54.4297 81.9529 55.0934 80.5268C56.0565 78.4657 57.7631 78.0525 59.6594 78.7529C61.5157 79.4383 62.1046 81.0408 61.895 82.1444Z",
    fill: "#F4A4C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8827 79.4102C82.728 77.4398 83.4915 75.7718 85.3728 74.6934C87.4138 73.5243 89.335 73.8368 90.9768 75.4241C91.885 76.301 92.5387 76.6638 93.8861 76.0591C95.7125 75.2377 97.5189 76.0037 98.7864 77.4801C100.174 79.0977 100.229 81.0076 99.3154 82.9377C97.8383 86.0721 92.0297 89.3829 88.8061 88.9142C86.4856 88.5816 82.9426 82.9931 82.8827 79.4102Z",
    fill: "#0F1311"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7949 79.8135C84.8199 78.3924 84.9496 77.0318 86.5565 76.4624C88.0984 75.9131 89.6005 76.0492 90.4787 77.4904C91.347 78.9216 92.1105 79.4759 93.6575 78.4579C95.0947 77.5106 96.5618 77.7726 97.5748 79.1584C98.6476 80.6248 97.9041 82.1114 96.951 83.2402C95.0248 85.5129 92.395 86.6316 89.5007 86.8433C87.3599 86.9995 84.7899 82.9882 84.7949 79.8135Z",
    fill: "#F3A4C6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.586 0.00119698L83.2762 28.8158L92.8846 30.511L87.8599 49.6113L106.379 21.9958L96.295 21.6566L103.586 0.00119698Z",
    fill: "url(#paint1_linear_6334_53592)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.9867,
    cy: 73.3413,
    rx: 1.98863,
    ry: 1.91943,
    fill: "#263238"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.40804,
    height: 27.0949,
    rx: 2.70402,
    transform: "matrix(0.886125 0.463447 -0.48953 0.871986 45.2031 44)",
    fill: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7658 80.7298C22.929 79.2776 20.6872 78.3839 18.324 78.1615C15.9609 77.9391 13.5825 78.398 11.4896 79.4803C9.39665 80.5626 7.68325 82.2196 6.56603 84.2418C5.44881 86.264 4.97794 88.5605 5.21298 90.841C5.44802 93.1215 6.3784 95.2835 7.88647 97.0536C9.39455 98.8237 11.4126 100.122 13.6854 100.786C15.9582 101.449 18.3837 101.446 20.6551 100.779C22.9266 100.112 24.942 98.8091 26.4464 97.0361",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 12.7912,
    ry: 11.7453,
    transform: "matrix(0.801368 -0.598171 0.625281 0.7804 18.452 89.5694)",
    fill: "url(#paint2_linear_6334_53592)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1219 95.4907C20.2015 95.0607 21.1003 94.2934 21.6744 93.3118C22.2485 92.3301 22.4647 91.1909 22.2883 90.0766C22.1118 88.9623 21.553 87.9374 20.7014 87.166C19.8498 86.3946 18.7546 85.9215 17.5912 85.8223",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6334_53592",
    x1: 71.2934,
    y1: 4.98828,
    x2: 81.998,
    y2: 87.9883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534375,
    stopColor: "#8A95C6",
    stopOpacity: 0.86896
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961458,
    stopColor: "#68BFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6334_53592",
    x1: 91.7922,
    y1: 1.49865,
    x2: 97.5797,
    y2: 47.0816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEEB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6334_53592",
    x1: 12.7912,
    y1: 0,
    x2: 12.7912,
    y2: 23.4906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D99FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADE2FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpgrade);
export default __webpack_public_path__ + "static/media/icon-upgrade.bd4638d4.svg";
export { ForwardRef as ReactComponent };